<template>
    <Dialog
        v-model:visible="showUnauthorizedAccessDialog"
        :draggable="false"
        :close-on-escape="false"
        :closable="false"
        :dismissableMask="false"
        :block-scroll="true"
        modal
        class="max-w-1/2 md:max-w-1/3 m-2 md:m-4"
        :show-header="true"
        :header="$t('dialog.unauthorizedAccess.title')"
        data-testid="unauthorized-access-dialog"
    >
        <div class="flex flex-col items-center justify-center gap-2">
            <p class="text-center">
                {{ $t('dialog.unauthorizedAccess.message') }}
            </p>
            <Button
                class="mt-2"
                type="button"
                :label="$t('auth.logout')"
                @click="logout"
                data-testid="unauthorized-logout-button"
            />
        </div>
    </Dialog>
</template>

<script setup lang="ts">
    import useAuthStore from '@/stores/useAuthStore';
    import useDialogStore from '@/stores/useDialogStore';
    import { storeToRefs } from 'pinia';

    const authStore = useAuthStore();
    const dialogStore = useDialogStore();
    const { showUnauthorizedAccessDialog } = storeToRefs(dialogStore);

    const logout = async () => {
        showUnauthorizedAccessDialog.value = false;
        await authStore.logout();
    };
</script>
